import { render } from "./BaseForm.vue?vue&type=template&id=bb5b1c06&ts=true"
import script from "./BaseForm.vue?vue&type=script&lang=ts"
export * from "./BaseForm.vue?vue&type=script&lang=ts"

import "./BaseForm.vue?vue&type=style&index=0&id=bb5b1c06&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__